import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Forms from "../../../../Componets/Form";
import toast from "react-hot-toast";
import Header from "../../../../Componets/Header";
import {
  create_service,
  get_service,
  update_service,
} from "../../../../Controllers/Services/Services";
import { get_all_taxes } from "../../../../Controllers/Tax/Tax";
import forms from "../../../../Data/Forms/Services/Services/forms";
import headers from "../../../../Data/Forms/Services/Services/headers";
import Loadercomponent from "../../../../Componets/Loader";
import { convert_to_file } from "../../../../Controllers/Global";

const ServiceForm = () => {
  let { id } = useParams();
  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [values, setValues] = useState(forms);

  const formdata = async (data) => {
    if (data?.status) {
      setButtonLoader(true);

      const service = id
        ? await update_service({ ...data?.data, id: id })
        : await create_service({ ...data?.data });

      if (service?.status) {
        navigate(-1);
        toast?.success(service?.message);
        setButtonLoader(false);
      } else {
        setButtonLoader(false);
        if (service?.status_code == 403) {
          window.location.href = "/unauthorized";
        } else {
          toast?.error(service?.message);
        }

      }
    }
  };

  const handleData = async (service) => {
    let image = service?.image ? service?.image : "";
    let file = await convert_to_file(image);
    let name = service?.name ? service?.name : "";
    let code = service?.code ? service?.code : "";
    let category = service?.category?._id ? service?.category?._id : null;
    let duration = service?.duration ? service?.duration : "";
    let description = service?.description ? service?.description : "";
    let cost_price = service?.cost_price ? service?.cost_price : "";
    let sale_price = service?.sale_price ? service?.sale_price : "";
    let tax = service?.tax?._id ? service?.tax?._id : null;
    let status = service?.status ? service?.status : 1;

    let category_option = service?.category?._id
      ? [{ value: service?.category?._id, label: service?.category?.name }]
      : null;
    let tax_option = service?.tax?._id
      ? [{ value: service?.tax?._id, label: service?.tax?.name }]
      : null;

    values[0].options[0].form.value = file;
    values[0].options[1].form.value = name;
    values[0].options[2].form.value = code;

    values[1].options[0].form.value = category;
    values[1].options[0].form.options = category_option;
    values[1].options[1].form.value = duration;

    values[2].options[0].form.value = description;

    values[3].options[0].form.value = cost_price;
    values[3].options[1].form.value = sale_price;

    values[4].options[0].form.value = tax;
    values[4].options[0].form.options = tax_option;

    values[5].options[0].form.value = status;

    setLoader(false);
    setValues([...values]);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const service = await get_service(data);
      if (service?.status) {
        handleData(service?.data);
      } else {
        toast?.error(service?.message);
      }
    } else {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Forms
          form={values}
          setForm={setValues}
          formdata={formdata}
          buttonLoader={buttonLoader}
        />
      </Loadercomponent>
    </Header>
  );
};

export default ServiceForm;